import * as React from "react";
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChart } from "../components/ComponentChart";
import { ComponentTable } from "../components/ComponentTable";
import { SlideContext } from "../Context";
import { REPORT_ID } from "../constants";

export const slide35ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_ID === identification.reportId) {
    if (identification.componentId === "line-chart") {
      input.component = <ComponentChart context={componentContext as SlideContext}></ComponentChart>;
    }
    if (identification.componentId === "table") {
      input.component = <ComponentTable context={componentContext as SlideContext}></ComponentTable>;
    }
  }
  return next(input);
};
